import React from "react";
import styled from "styled-components";
import { Link as ScrollLink } from "react-scroll";

const HeroSection3 = () => {
  return (
    <Hero>
      <div className="hero-content">
        <p className="left-data">Diesel Exhaust Fluid</p>
        <p className="hero-para">
          Suitable for all BS-IV & BS-VI Diesel engine vehicles
        </p>
        <span className="company-name-span">By <span style={{fontWeight:"500",fontSize:"1rem"}}>MShine Enterprises</span></span>
        <ScrollLink
          className="btn btn-light hero-contact-btn"
          to="contact"
          spy={true}
          smooth={true}
          offset={-70}
          duration={100}
        >
          Contact Us
        </ScrollLink>
      </div>
    </Hero>
  );
};

const Hero = styled.section`
  padding-top: 56px;
  background-image: url(${process.env.PUBLIC_URL}/adobe20.jpg);
  background-size: cover;
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Prevent background from repeating */

  display: flex;
  width: 100%;

  height: 100vh;

  .company-name-span{
    color: black;
    font-size: 0.8rem;
    width: 100%;
    text-align: start;
    margin-bottom: 24px;

   
  }

  .hero-content {
    width: 100%;
    height: 100%; /* Full height of parent */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start; /* Align items to the left */
    padding-left: 20px; /* Add padding to keep text away from edge */
    //background: rgba(0, 0, 0, 0.5); /* Optional: Add semi-transparent background for readability */
    color: white; /* Text color for readability */
    max-width: 50%; /* Restrict content width to 50% of the screen */

   
  }

  .left-data {
    padding: 5px;
    //background-color: rgba(255, 255, 0, 0.7); /* Semi-transparent yellow */
    font-family: "Play", sans-serif;
    font-optical-sizing: auto;
    font-weight: 900;
    font-style: italic;

    font-size: 70px;
    color: #000000;
    text-shadow: 5px 2px #fff;
  }

  .hero-para {
    padding: 5px;
    color: #000000; /* Semi-transparent aqua */
    max-width: 100%; /* Ensure text container does not overflow */
    font-family: "Play", sans-serif;
    font-optical-sizing: auto;
    font-weight: 500;
    font-style: normal;
    margin-bottom: 0;

    font-size: 32px;
  }
 
  .hero-contact-btn{
    width: 180px;
    color: white;
    background-color: #2363e7;
    font-weight: 500;
    max-height: none;
    /* height: 99px !important; */
    padding: 10px 20px;
    border-radius: 30px;
    outline: 2px solid #2363e7;
    outline-offset: 3px;
    text-transform: uppercase;

  }

  .btn:hover {
    background-color:	rgb(255, 191, 0);
    /* transform: translateX(1px); */
    font-weight: 700;
    color: white;
  }

  @media (max-width: 768px) {
    padding-top: 20px;
    background-size: contain;
  }

  @media (max-width: 480px) {
    background-size: contain;
    .hero-para {
    font-size: 25px;
  }
  .left-data {
      font-size: 35px; /* Further reduce the size for mobile */
    }
  }

  @media (orientation: landscape)  {
    min-height: 700px;
    padding-top: 200px;
  }
`;

export default HeroSection3;